import React from 'react';
import { ListChecks, Activity,
  FileText, Thermometer, Pill, Droplet, FileEdit,
  ClipboardList, Bandage, AlertTriangle, Ruler, MessageSquarePlus,
  Wind, Zap, Beaker, UserCheck
} from 'lucide-react';

interface EntryIconProps {
  type: string | null;
}

// Component to render entry icon based on type using JSX
export const EntryIcon: React.FC<EntryIconProps> = ({ type }) => {
  if (!type) return <FileText size={18} className="mr-2" />;

  switch (type.toLowerCase()) {
    case 'vitals':
      return <Thermometer size={18} className="mr-2 text-blue-700" />;
    case 'mar':
      return <Pill size={18} className="mr-2 text-green-700" />;
    case 'feed':
      return <Droplet size={18} className="mr-2 text-amber-700" />;
    case 'notes':
      return <FileEdit size={18} className="mr-2 text-purple-700" />;
    case 'wound':
      return <Bandage size={18} className="mr-2 text-pink-700" />;
    case 'incident':
      return <AlertTriangle size={18} className="mr-2 text-red-700" />;
    case 'summary':
      return <ClipboardList size={18} className="mr-2 text-slate-700" />;
    case 'measurements':
      return <Ruler size={18} className="mr-2 text-yellow-700" />;
    case 'addendum':
      return <MessageSquarePlus size={18} className="mr-2 text-indigo-700" />;
    case 'respiratory':
      return <Wind size={18} className="mr-2 text-cyan-700" />;
    case 'seizure':
      return <Zap size={18} className="mr-2 text-orange-700" />;
    case 'output':
      return <Beaker size={18} className="mr-2 text-lime-700" />;
    case 'supervisory':
      return <UserCheck size={18} className="mr-2 text-teal-700" />;
    case 'therapy':
      return <Activity size={18} className="mr-2 text-emerald-700" />;
    case 'aidetasks':
      return <ListChecks size={18} className="mr-2 text-lime-700" />;
    default:
      return <FileText size={18} className="mr-2" />;
  }
};
